import './index.css';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Fragment } from 'react';
import { validateSurface } from '../../globals.js';
import { Tooltip } from '../tooltip/index.js';
import styles from './trailing-tooltip.module.scss.js';

const TrailingTooltip = ({ surface: surfaceProp = 'lightPrimary', id, text = { size: 'small', bold: false, kind: 'body', primitive: 'span' }, tooltip, children, }) => {
    const surface = validateSurface(surfaceProp);
    function _formatChildren(childArray) {
        let textWithoutIcon = '';
        childArray.forEach((item, index) => {
            if (index !== childArray.length - 1) {
                textWithoutIcon += `${item} `;
            }
        });
        return textWithoutIcon;
    }
    function checkForNode() {
        const ignoreFragments = (childrenArray) => {
            if (!Array.isArray(childrenArray)) {
                return childrenArray;
            }
            return (childrenArray &&
                childrenArray
                    .filter((child) => typeof child !== 'boolean')
                    .map((child) => {
                    if (child.type === Fragment) {
                        return child.props.children instanceof Array
                            ? child.props.children[0]
                            : child.props.children;
                    }
                    return child;
                }));
        };
        const _children = children ? ignoreFragments(children) : children;
        const lastIndex = _children.length - 1; // number of last index in child array
        const lastChild = _children[lastIndex]; // last child in child array
        const isNode = typeof _children[lastIndex] !== 'string'; // if last child is node
        const isString = typeof _children === 'string'; // if _children are a string
        const firstNodes = [];
        if (_children.length === undefined || _children.length <= 1)
            return { childArray: [], textWithIcon: _children }; // if only one child put with caret and return
        if (isNode || !isString) {
            // if the last child is node or mixture put last with the caret
            _children.forEach((child, index) => {
                // add all _children to first nodes except the last one
                if (index !== lastIndex)
                    firstNodes[index] = child;
            });
            return { childArray: firstNodes, textWithIcon: lastChild };
        }
        // if all _children are "strings", put last word with tooltip
        if (typeof _children === 'string') {
            const childArray = _children.trim().split(' ');
            const textWithIcon = childArray[childArray.length - 1];
            return { childArray: _formatChildren(childArray), textWithIcon };
        }
    }
    function _renderWithIcon() {
        const childArray = children ? checkForNode().childArray : [];
        const textWithIcon = children ? checkForNode().textWithIcon : '';
        const inlineWrapperStyle = [styles.inlineWrapper, styles[tooltip === null || tooltip === void 0 ? void 0 : tooltip.size]];
        const childWrapperStyles = [styles.childWrapper];
        if (tooltip === null || tooltip === void 0 ? void 0 : tooltip.size) {
            if (tooltip.size === 'small') {
                if ((text === null || text === void 0 ? void 0 : text.kind) === 'micro' ||
                    ((text === null || text === void 0 ? void 0 : text.kind) === 'body' && (text === null || text === void 0 ? void 0 : text.size) === 'small')) {
                    childWrapperStyles.push(styles.textSmall);
                }
            }
            else if (tooltip.size === 'medium') {
                if ((text === null || text === void 0 ? void 0 : text.kind) === 'body' ||
                    ((text === null || text === void 0 ? void 0 : text.kind) === 'title' && (text === null || text === void 0 ? void 0 : text.size) === '2xsmall')) {
                    childWrapperStyles.push(styles.textSmall);
                }
            }
        }
        return (jsxs("span", { className: styles.wrapper, children: [childArray, jsxs("span", { style: {
                        maxHeight: 
                        // eslint-disable-next-line no-nested-ternary
                        (text === null || text === void 0 ? void 0 : text.kind) === undefined
                            ? `var(--vds-typography-body-small-lineheight)`
                            : // eslint-disable-next-line no-nested-ternary
                                (text === null || text === void 0 ? void 0 : text.kind) === 'micro'
                                    ? `var(--vds-typography-micro-lineheight)`
                                    : (text === null || text === void 0 ? void 0 : text.size) === undefined
                                        ? `var(--vds-typography-${text === null || text === void 0 ? void 0 : text.kind}-small-lineheight)`
                                        : `var(--vds-typography-${text === null || text === void 0 ? void 0 : text.kind}-${text === null || text === void 0 ? void 0 : text.size}-lineheight)`,
                    }, className: childWrapperStyles.join(' '), children: [textWithIcon, jsx("span", { className: inlineWrapperStyle.join(' '), children: jsx("span", { className: styles.inlineInnerWrapper, children: jsx(Tooltip, Object.assign({}, tooltip, { surface: surface, children: jsx("span", { className: styles.tooltipContent, children: tooltip && tooltip.children }) })) }) })] })] }));
    }
    const typographyStyles = text && text.size
        ? [
            styles.typographyWrapper,
            styles[surface.toLowerCase()],
            styles[text.size],
        ]
        : [styles.typographyWrapper, styles[surface.toLowerCase()]];
    switch (text && text.kind) {
        case 'title':
            if (typographyStyles != null)
                typographyStyles.push(styles.title);
            break;
        case 'feature':
            if (typographyStyles != null)
                typographyStyles.push(styles.feature);
            break;
        case 'micro':
            if (typographyStyles != null)
                typographyStyles.push(styles.micro);
            break;
    }
    if (text && text.size === '2xlarge' && text.kind === 'title')
        if (typographyStyles != null)
            typographyStyles.push(styles.twoxlarge);
    if (text && text.size === '2xsmall' && text.kind === 'title')
        if (typographyStyles != null)
            typographyStyles.push(styles.twoxsmall);
    if (text && text.bold && typographyStyles != null)
        typographyStyles.push(styles.bold);
    const PrimitiveElement = text && text.primitive ? text.primitive : 'span';
    return (jsx(PrimitiveElement, { style: { color: text && text.color }, className: typographyStyles.join(' '), id: id, children: _renderWithIcon() }));
};

export { TrailingTooltip, TrailingTooltip as default };
